import React, { useState, useEffect } from 'react'

import { Grid, Typography, Box, Divider } from '@material-ui/core'
import ChevronRightIcon from '@material-ui/icons/ChevronRight'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import TreeItem from '@material-ui/lab/TreeItem'
import TreeView from '@material-ui/lab/TreeView'
import { date } from 'yup/lib/locale'

import useStyles from '../ReportsAccountStyle'

import CardBody from 'components/Card/CardBody.js'
import convertToCurrencyCop from 'utils/convertToCurrencyCop'

const datatable = {
  id: 'root',
  name: 'Cobros extra',
  children: [
    {
      id: '1',
      name: 'Servicio de comisión',
    },
    {
      id: '2',
      name: 'Penalidad por cancelación',
    },
    {
      id: '3',
      name: 'penalidad por envios',
    },
    {
      id: '4',
      name: 'Retefuente (Servicios de comisión)',
    },
  ],
}
const OrdersSection = ({ dataOrders }) => {
  const { order } = dataOrders
  const [data, setData] = useState(datatable)

  useEffect(() => {
    if (order) {
      const extraChargeLet = order?.extraCharge || {}
      setData({
        id: 'root',
        name: 'Cobros extra',
        children: [
          {
            id: '1',
            name: 'Servicios de comisión',
            value: extraChargeLet.commisionService,
          },
          {
            id: '2',
            name: 'Penalidad por cancelación',
            value: extraChargeLet.cancelPenalty,
          },
          {
            id: '3',
            name: 'penalidad por envios',
            value: extraChargeLet.shippingPenalty,
          },
          {
            id: '4',
            name: 'Retefuente (Servicios de comisión)',
            value: extraChargeLet.retuntPenalty,
          },
        ],
      })
    }
  }, [order])
  const renderTree = (nodes, classes) => {
    return (
      <>
        {(nodes?.value || nodes.value !== 0) && (
          <TreeItem
            key={nodes.id}
            nodeId={nodes.id}
            label={
              <Grid container justify="space-between" alignItems="center">
                <Typography
                  component="div"
                  className={
                    nodes.id === 'root' ? classes.letterSpacingRoot : classes.letterSpacing
                  }
                >
                  {nodes.name}
                </Typography>

                <Typography component="div" className={classes.letterSpacing}>
                  {nodes.value && `$${convertToCurrencyCop(Number(nodes.value || 0))} COP`}
                </Typography>
              </Grid>
            }
          >
            {Array.isArray(nodes.children)
              ? nodes.children.map((node) => renderTree(node, classes))
              : null}
          </TreeItem>
        )}
      </>
    )
  }
  const classes = useStyles()
  return (
    <>
      <Grid container direction="row" justify="flex-start" alignItems="flex-start">
        <Typography variant="subtitle2" className={classes.widthInitialBalance}>
          Pedidos
        </Typography>
        <Grid
          container
          justify="space-between"
          alignItems="flex-start"
          className={classes.InitialBalancePadding}
        >
          <Typography align="left" className={classes.widthCloseInitialBalance}>
            Ingresos por venta
          </Typography>
          <Typography align="right" className={classes.widthValueRigth}>
            {`$${convertToCurrencyCop(Number(order?.incomeSales || 0))} COP`}
          </Typography>
          <Typography align="left" className={classes.widthCloseInitialBalance}>
            Otros ingresos
          </Typography>
          <Typography align="right" className={classes.widthValueRigth}>
            {`$${convertToCurrencyCop(Number(order?.otherIncome || 0))} COP`}
          </Typography>
          <TreeView
            className={classes.root}
            defaultCollapseIcon={<ExpandMoreIcon />}
            defaultExpanded={['root']}
            defaultExpandIcon={<ChevronRightIcon />}
          >
            {renderTree(data, classes)}
          </TreeView>
        </Grid>
      </Grid>
      <Divider />
      <Grid container direction="row" justify="flex-end" alignItems="flex-start">
        <Typography variant="subtitle1">Subtotal</Typography>
        <Typography align="right" className={classes.widthValueInitialBalance}>
          {`$${convertToCurrencyCop(Number(order?.orderSubTotal || 0))} COP`}
        </Typography>
      </Grid>
    </>
  )
}
export default OrdersSection
